import { render } from "./unggahBukti.vue?vue&type=template&id=1493adaa&scoped=true"
import script from "./unggahBukti.vue?vue&type=script&lang=js"
export * from "./unggahBukti.vue?vue&type=script&lang=js"

import "./unggahBukti.vue?vue&type=style&index=0&id=1493adaa&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Pulih_Anita/frontend-pulih/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1493adaa"]])

export default __exports__